interface SectionHeadingProps {
  index: string;
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  description,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`flex flex-col gap-4 ${isCenter ? 'items-center text-center' : 'items-start'}`}>
      <div className={`flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`}>
        <span className="font-heading text-sm font-semibold text-primary-600">{index}</span>
        <span className="h-px w-10 bg-primary-300" aria-hidden="true"></span>
        {eyebrow ? (
          <span className="font-label text-xs tracking-[0.3em] text-foreground-500">{eyebrow}</span>
        ) : null}
      </div>
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {description ? (
        <p className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? 'mx-auto' : ''}`}>
          {description}
        </p>
      ) : null}
    </div>
  );
}